import { render, staticRenderFns } from "./userDashboardNutritionMealPlan.vue?vue&type=template&id=15f565d4"
import script from "./userDashboardNutritionMealPlan.vue?vue&type=script&lang=js"
export * from "./userDashboardNutritionMealPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports